export const constants = {
    AFL: 'Australian Football League',
    CRICKET_AUSTRALIA: 'Cricket Australia',
    TRUE: true,
    FALSE: false,
    ASSOCIATION: 'Association',
    CLUB: 'Club',
    CHECKLIST: 'checklist',
    ITEM_ID: 'itemId',
    ITEM_CREATED_DT: 'itemCreatedDT',
    ORGANISATION: 'organisation',
    ADDRESS: 'address',
    PARTIES: 'parties',
    RISK: 'risk',
    DECLARATION: 'declaration',
    ACCESSIBLE_MODE: 'accessibleMode',
    CRICINFO: 'cricInfo',
    VIEW: 'VIEW',
    EDIT: 'EDIT',
    NEW: 'NEW',
    YES: 'Yes',
    NO: 'No',
    EMPTY: '',
    SPACE: ' ',
    QUERY_PARAMS: 'queryParams',
    RISK_QUESTIONARY: 'riskQuestionary',
    PAGE: {
        CHECKLIST: 'page/checklist',
        ADDRESS: '/page/address',
        ORGANISATION: 'page/organisation',
        PARTIES: '/page/parties',
        RISK: 'page/risk',
        DECLARATION: 'page/declaration',
        FAQ: 'page/faq'
    },
    TEAM: {
        HOME_TEAM: 'Home Team',
        AWAY_TEAM: 'Away Team',
        HOME_TEAM_REPRESENTATIVE: 'Home Team Representative',
        AWAY_TEAM_REPRESENTATIVE: 'Away Team Representative'
    },
    REGEX: {
        ALPHA_NUMERIC: '^[a-zA-Z0-9 ]+$',
        NUMERIC: '^[0-9 ]+$',
        ALPHA_NUMERIC_SPECIAL_CHARS: "^[a-zA-Z0-9 .,;'()-_?&]+$",
        ALPHA_NUMERIC_SPECIAL_CHARS_RETURN: "^[a-zA-Z0-9 .,;'()-_?& \r\n]+$",
    },
    MESSAGE: {
        PROCESSED: 'Item Processed Successfully.',
        SUBMITTED: 'Item Submitted Successfully.',
        FILL_ALL: 'Please fill the all informations.',
        FILL_ORGANISATION: 'Please fill the organisation informations.',
        FILL_ADDRESS: 'Please fill the address informations.',
        FILL_PARTIES: 'Please fill the parties informations.',
        FILL_RISK: 'Please fill the risk informations.'
    }
}